import React, { useState } from "react"
import { useSelector } from "react-redux"

import { MtMailTemplate } from "server/models"
import {
    useInput,
    replacePlaceholders,
    TextPlaceholders,
} from "client/utils"
import {
    MAIL_SETTING_FROM_EMAIL,
    MAIL_TEMPLATE_RESET_PASSWORD,
    StoreType,

    LoadUserByLoginOrEmail,
    CreateConfirmationCodeByEmail,
    ChangeUserConfirmationCode,
    LoadMailSettingByName,
    LoadMailTemplateByName,
    SendMail,
} from "client/store"

import * as routes from "client/parts/routes"
import { Footer } from "client/parts/layout"
import {
    Loader,
    FormGroup,
    Feedback,
    LostConnection,
} from "client/components"
import {
    AuthWrapper,
    AuthTitle,
    AuthFormWrapper,
    AuthForm,
    AuthFormDescription,
    AuthInput,
    AuthButton,
    SuccessfulAuthWrapper,
} from "./styled"

const ForgotPassword = () => {
    const [email, setEmail] = useInput("")

    const [notFound, setNotFound] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isSent, setIsSent] = useState(false)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const lostServerConnection = useSelector((state: StoreType) => state.system.lostServerConnection)

    const onConfirm = () => {
        setIsLoading(true)

        LoadUserByLoginOrEmail(email).then((user) => {
            if (!user) {
                setNotFound(true)
                setIsLoading(false)
                return
            }

            const confirmationCode = CreateConfirmationCodeByEmail(email)

            let fromEmail: string
            let resetPassword: MtMailTemplate = null

            Promise.all([
                ChangeUserConfirmationCode(user.id, confirmationCode),
                LoadMailSettingByName(MAIL_SETTING_FROM_EMAIL).then((mailSetting) => {
                    fromEmail = mailSetting ? mailSetting.value : ""
                }),
                LoadMailTemplateByName(MAIL_TEMPLATE_RESET_PASSWORD).then((mailTemplate) => {
                    resetPassword = mailTemplate
                }),
            ]).then(() => {
                const placeholders: TextPlaceholders = {
                    user: `${user.firstName} ${user.lastName}`,
                    email: user.email,
                    confirmLink: `${document.location.origin}${routes.resetPasswordRoute}/${confirmationCode}`,
                }

                SendMail({
                    from: fromEmail,
                    to: user.email,
                    subject: resetPassword ? resetPassword.subject : "",
                    html: resetPassword ? replacePlaceholders(resetPassword.content, placeholders) : "",
                }).then(() => {
                    setIsSent(true)
                    setIsLoading(false)
                })
            })
        })
    }

    const allowSending = email.length

    return (
        <AuthWrapper>
            { lostServerConnection && <LostConnection /> }
            { isLoading && <Loader paddingTop={250} /> }

            <AuthFormWrapper show={!isSent}>
                <AuthTitle>{lang.forgotPassword}</AuthTitle>
                <AuthForm>
                    <AuthFormDescription>{lang.forgotPasswordDescription}</AuthFormDescription>
                    <FormGroup>
                        <AuthInput type="text" value={email} onChange={setEmail} placeholder={lang.email} />
                        <Feedback>{notFound && lang.userNotFound}</Feedback>
                    </FormGroup>

                    <AuthButton
                        variant="success"
                        disabled={!allowSending}
                        onClick={onConfirm}
                    >
                        {lang.resetPassword}
                    </AuthButton>
                </AuthForm>
            </AuthFormWrapper>

            <SuccessfulAuthWrapper show={isSent}>
                <AuthTitle>{lang.emailSent}</AuthTitle>
                <AuthFormDescription>{lang.checkEmailAndResetPassword}</AuthFormDescription>
            </SuccessfulAuthWrapper>

            <Footer />
        </AuthWrapper>
    )
}
export default ForgotPassword
